import React from "react";

const ITEMS = [
  "BNW Developments", "Emaar", "Nakheel", "OMNIYAT", "Sobha Realty", "Aldar", "Binghatti", "DAMAC", "Select Group",
  "Palm Jumeirah", "Dubai Marina", "Business Bay", "Saadiyat Island", "Yas Island", "Al Marjan Island",
  "Prime global demand", "Attractive yields", "10-year Golden Visa", "0% capital gains tax",
];

const Marquee = () => (
  <div className="overflow-hidden border-y border-[rgba(197,168,128,0.15)] bg-[#0D0F15] py-5" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track flex whitespace-nowrap w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center">
              <span className="font-display italic text-lg text-[#C5A880]/80 px-8">{item}</span>
              <span className="w-1.5 h-1.5 rotate-45 bg-[#9A7B4F]/50" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
